module.exports = __webpack_public_path__ + "img/Zachary_Levi.c65018af.jpg";